import { Button, Checkbox, Divider, Drawer, Form, Input, Segmented, Slider, Space, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import CSS from "../../../utils/CSS";
import Html from "../../../utils/Html";
import { tt_name_block_warning, tt_sbs_padding_x, tt_sbs_padding_y } from "../../../utils/Utils";
import EmbedRenderer from "../EmbedRenderer";
import FormSelect from "../../FormSelect";
import { apiCall } from "../../../utils/Api";
import TextInputField from "../CustomForm/TextInputField"
import TextAreaField from "../CustomForm/TextAreaField"
import TextEmailField from "../CustomForm/TextEmailField"
import TextPhoneField from "../CustomForm/TextPhoneField"
import TextDateField from "../CustomForm/TextDateField"
import TextDayMonthField from "../CustomForm/TextDayMonthField"
import SelectBoxField from "../CustomForm/SelectBoxField"
import CheckBoxField from "../CustomForm/CheckBoxField";
import RadioField from "../CustomForm/RadioField";
import ColourPicker from "../../../globals/styles/ColourPicker";
import BMInput from "../../comps/BMInput";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import PresetPicker from "../../../globals/styles/PresetPicker";
import { getColor, getFontFamily } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import FontPicker from "../../../globals/styles/FontPicker";
import { useForm } from "antd/lib/form/Form";

export default function CustomForm(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const [form, setForm] = useState();
    const [f] = useForm();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }
    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        form_id = "",
        width = 30,
        padding_x = 10,
        padding_y = 10,
        show_heading = true,
        heading_align = "center",
        heading_preset = 0,
        show_description = true,
        description_align = "center",
        description_preset = 0,
        align = "0 auto",
        label_preset = 0,
        label_help_preset = 0,
        label_description_preset = 0,
        input_font = 0,
        button_label = "Submit",
        button_type = 0,
        button_block = true,
        background_colour = 0,
        gap = 0,
        layout = "vertical",
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }


    const getForm = () => {
        if (!form_id) {
            return;
        }
        apiCall("settings/custom_forms/get", { form_id: form_id, }, (_status, _result) => {
            if (_status) {
                setForm(_result);
            }
        })
    }

    useEffect(getForm, [form_id]);


    const drawElement = (_data) => {

        const _props = {
            label_description_class: "bm-txt-" + label_description_preset,
            label_help_class: "bm-txt-" + label_help_preset,
            label_class: "bm-txt-" + label_preset,
            form: f,
            data: _data,
            id: _data.id
        }

        switch (_data.type) {
            case "text":
                return (<TextInputField {..._props} />);
            case "textarea":
                return (<TextAreaField {..._props} />);
            case "email":
                return (<TextEmailField {..._props} />);
            case "phone":
                return (<TextPhoneField {..._props} />);
            case "date":
                return (<TextDateField {..._props} />);
            case "daymonth":
                return (<TextDayMonthField {..._props} />);
            case "select":
                return (<SelectBoxField {..._props} />);
            case "checkbox":
                return (<CheckBoxField {..._props} />);
            case "radio":
                return (<RadioField {..._props} />);
        }
    }


    const drawElements = (_formdata) => {
        return _formdata.elements.map(item => {
            return <div style={{ "width": (layout === "horizontal") ? "350px" : "100%" }}>{drawElement(item)}</div>;
        })
    }

    const drawCustomForm = () => {

        const _style = {
            background: getColor(background_colour, template),
        }

        const _align = {
            maxWidth: (1248 * (width / 100)) + "px",
            margin: align,
            padding: padding_y + "px " + padding_x + "px",
        }

        if (form) {
            return (
                <div style={_style}>

                    <div style={_align}>
                        <Form form={f} layout={"vertical"}>
                            {(show_heading &&
                                <h3 style={{ "display": "block", "textAlign": heading_align }} className={"bm-txt-" + heading_preset} >
                                    {form.header}
                                </h3>
                            )}
                            {(show_description &&
                                <>
                                    <div style={{ "display": "block", "textAlign": description_align }} className={"bm-txt-" + description_preset} >{form.description}</div>
                                    <div className="shim" /><div className="shim" />
                                </>
                            )}
                            <div className="form-format" style={{ "display": "flex", "justifyContent": "center", "flexWrap": "wrap", "alignItems": "flex-start", "flexDirection": (layout === "vertical") ? "column" : "row", gap: gap }}>
                                {drawElements(form)}
                                <Button block={button_block} className={"bm-btn-" + button_type + " nomargin"} >{button_label}</Button>
                            </div>
                        </Form>
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }


    }


  


    let _class = ``;

    _class += `
         #bm-${id} input, #bm-${id} textarea, #bm-${id} .ant-select-selection-item {
           font-family: '${getFontFamily(input_font, template)}' !important;
         }
            #bm-${id} .ant-input-textarea-show-count::after{
             display:none; 
            }
         .inlineforce{
            display: inline !important;
         } 
            .nomargin{
  margin: 0 !important;
} 
         `;

    const drawRender = () => {
        return (
            <>
                <CSS prepend html={_class} />
                <div id={"bm-" + id} className={(container) ? "preview-container bm-form-component" : "bm-form-component"}>
                    {drawCustomForm()}
                </div>
            </>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SELECT FORM</Divider>
                <FormSelect value={form_id} onChange={(e) => setData({ ...data, "form_id": e.list_id })} />
                <div className="shim" /> <div className="shim" />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sbs_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sbs_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                    </div>
                </div>
                <div className="shim" /> <div className="shim" />


                {/* FORM WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">FORM WIDTH</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        value={width}
                    />
                </div>

                {/* GAP */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">GAP</Divider>
                <div className="float-flex">
                    <Slider
                        style={{ "width": "100%" }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "gap": _v })}
                        value={gap}
                    />
                </div>
                <div className="shim" /><div className="shim" />

                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">STACK / ALIGN</Divider>
                <Space>
                    <Space>
                        <div><AlignLeftIcon onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignCenterIcon onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                        <div><AlignRightIcon onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                    <div>&nbsp;</div>
                    <Segmented size="small" value={layout} onChange={(e) => setData({ ...data, "layout": e })} options={[{ label: <small>Vertical</small>, value: "vertical" }, { label: <small>Horizontal</small>, value: "horizontal" }]} />
                </Space>
                <div className="shim" /> <div className="shim" />



                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>



                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW HEADING</Divider>
                <Checkbox checked={show_heading} onChange={(e) => setData({ ...data, "show_heading": e.target.checked })}><small>Show heading?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                {(show_heading &&
                    <>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADLINE PRESET</Divider>
                        <PresetPicker value={heading_preset} onChange={(e) => setData({ ...data, "heading_preset": e })} />
                        <div className="shim" /><div className="shim" />
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">HEADING ALIGN</Divider>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "heading_align": "left" })} style={{ "color": (heading_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "heading_align": "center" })} style={{ "color": (heading_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "heading_align": "right" })} style={{ "color": (heading_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                        <div className="shim" /><div className="shim" />
                    </>
                )}

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW DESCRIPTION</Divider>
                <Checkbox checked={show_description} onChange={(e) => setData({ ...data, "show_description": e.target.checked })}><small>Show description?</small></Checkbox>
                <div className="shim" /><div className="shim" />

                {(show_description &&
                    <>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION PRESET</Divider>
                        <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                        <div className="shim" /><div className="shim" />
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION ALIGN</Divider>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "description_align": "left" })} style={{ "color": (description_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "description_align": "center" })} style={{ "color": (description_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "description_align": "right" })} style={{ "color": (description_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                        <div className="shim" /><div className="shim" />
                    </>
                )}


                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL PRESET</Divider>
                <PresetPicker value={label_preset} onChange={(e) => setData({ ...data, "label_preset": e })} />
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL DESCRIPTION PRESET</Divider>
                <PresetPicker value={label_description_preset} onChange={(e) => setData({ ...data, "label_description_preset": e })} />
                <div className="shim" /><div className="shim" />

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LABEL HELP PRESET</Divider>
                <PresetPicker value={label_help_preset} onChange={(e) => setData({ ...data, "label_help_preset": e })} />
                <div className="shim" /><div className="shim" />


                {/* FONT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">INPUT FONT</Divider>
                <FontPicker value={input_font} onChange={(e) => setData({ ...data, "input_font": e })} />

                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>

                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON LABEL</Divider>
                <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                <Checkbox disabled={(!button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}